import {Injectable} from 'ng-metadata/core';


@Injectable()
export class EndlessScrollingUtil{
        private isSearchEnabled= true;
        
        constructor(){
        }
        
        
        public disableSearchEndlessScrolling(){
            this.isSearchEnabled= false;
        }
    
        public enableSearchEndlessScrolling(){
            this.isSearchEnabled= true;
        }
    
        public get isSearchEndlessScrollingEnabled(){
            return this.isSearchEnabled;
        }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/endlessScollingUtil.service.ts